import { onClickOutside } from "../utils/click-outside";

// handle login
export function registerLogin() {
  const loginToggles = document.getElementsByClassName("login-toggle");

  for (let loginToggle of loginToggles) {
    loginToggle.addEventListener("click", (e) => {
      e.stopImmediatePropagation();
      const loginModal = document.getElementById("login-modal");

      if (loginModal.classList.contains("hidden")) {
        loginModal.classList.remove("hidden");
        onClickOutside(loginModal.getElementsByClassName("modal")[0], () => loginModal.classList.add("hidden"));

        // hide dropdowns
        const dropdowns = document.getElementsByClassName("dropdown-toggle");
        for (let dropdown of dropdowns) {
          if (!dropdown.nextElementSibling.classList.contains("hidden")) {
            dropdown.nextElementSibling.classList.add("hidden");
          }
        }

        // hide register
        const registerModal = document.getElementById("register-modal");
        if (!registerModal.classList.contains("hidden")) {
          registerModal.classList.add("hidden");
        }
      } else {
        loginModal.classList.add("hidden");
      }
    });
  }

  const loginForm = document.getElementById("login-form");
  if (loginForm) {
    loginForm.addEventListener("submit", (event) => {
      event.preventDefault();
      let err = loginForm.getElementsByClassName("error")[0];
      err.classList.add("hidden");

      let body = {};

      const inputs = loginForm.getElementsByTagName("input");
      for (let input of inputs) {
        body[input.name] = input.value;
      }

      fetch(`/api/auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
        .then((res) => res.json())
        .then((json) => {
          window.location.reload();
        })
        .catch(() => {
          // display error
          err.classList.remove("hidden");
          err.textContent = "Niepoprawne dane logowania";
        });
    });
  }
}

// handle registration
export function registerRegister() {
  const loginToggles = document.getElementsByClassName("register-toggle");

  for (let loginToggle of loginToggles) {
    if (loginToggle) {
      loginToggle.addEventListener("click", (e) => {
        e.stopImmediatePropagation();
        const loginModal = document.getElementById("register-modal");

        if (loginModal.classList.contains("hidden")) {
          loginModal.classList.remove("hidden");
          onClickOutside(loginModal.getElementsByClassName("modal")[0], () => loginModal.classList.add("hidden"));

          // hide dropdowns
          const dropdowns = document.getElementsByClassName("dropdown-toggle");
          for (let dropdown of dropdowns) {
            if (!dropdown.nextElementSibling.classList.contains("hidden")) {
              dropdown.nextElementSibling.classList.add("hidden");
            }
          }

          // hide login
          const regiserModal = document.getElementById("login-modal");
          if (!regiserModal.classList.contains("hidden")) {
            regiserModal.classList.add("hidden");
          }
        } else {
          loginModal.classList.add("hidden");
        }
      });
    }
  }

  const registerForm = document.getElementById("register-form");
  if (registerForm) {
    registerForm.addEventListener("submit", (event) => {
      event.preventDefault();
      let err = registerForm.getElementsByClassName("error")[0];
      err.classList.add("hidden");

      let body = {};

      const inputs = registerForm.getElementsByTagName("input");
      for (let input of inputs) {
        body[input.name] = input.value;
      }

      fetch(`/api/user`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
        .then((res) => {
          if (res.status !== 200) {
            throw res.json();
          }
          return res.json();
        })
        .then((json) => {
          window.location.reload();
        })
        .catch((er) => {
          er.then((errObj) => {
            err.classList.remove("hidden");
            err.textContent = errObj && errObj.msg;
          });
        });
    });
  }
}
